// Optional reference enrichment must not turn a failed lookup into a manual order.
export const sourceLookupUnavailable = order => order?.source_resolution_status === 'unavailable';

export const orderSourceLabel = (order, fallback = 'Unknown Source') => (
  sourceLookupUnavailable(order) ? 'Source lookup unavailable'
    : (order?.resolved_source || (fallback === 'Manual' && order?.network_source ? 'Unknown Source' : fallback))
);
